import React, { useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Box,
  CardActions,
  Button,
} from "@mui/material";
import SearchBox from "../../components/reusableComponents/SearchBox";

const courses = [
  {
    id: 1,
    name: "React Basics",
    thumbnail: "https://i.ytimg.com/vi/bMknfKXIFA8/maxresdefault.jpg",
    lessons: "https://www.youtube.com/embed/bMknfKXIFA8",
  },
  {
    id: 2,
    name: "JavaScript Essentials",
    thumbnail: "https://i.ytimg.com/vi/W6NZfCO5SIk/maxresdefault.jpg",
    lessons: "https://www.youtube.com/embed/W6NZfCO5SIk",
  },
];

const CoursePage = () => {
  const [searchTerm, setSearchTerm] = useState(""); // Add search term state

  const handleSearchInput = (value) => {
    setSearchTerm(value); // Update search term state
  }

  // Filter courses based on search term
  const filteredCourses = courses.filter(course =>
    course.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ p: 3 }}>
      <h2 >{'Courses'}</h2>

      <Box mt={2}>
        <Box sx={{ width: 400, mb: 2 }}>
          <SearchBox handleSearchInput={handleSearchInput} />
        </Box>
        <Grid container spacing={4}>
          {filteredCourses.map((course) => (
            <Grid item xs={12} md={6} lg={3} key={course.id}>
              <Card
                sx={{
                  cursor: "pointer",
                  transition: "0.3s",
                  "&:hover": { boxShadow: 6 },
                }}
              >
                <CardMedia
                  component="img"
                  height="180"
                  image={course.thumbnail}
                  alt={course.name}
                />
                <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h6">{course.name}</Typography>
                </CardContent>

                <CardActions>
                  <a href={course?.lessons} target="_blank"
                    className="gn-actionbtn w-100 text-center" style={{ textDecoration: "none" }}>
                    Watch On YouTube
                  </a>
                </CardActions>

              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CoursePage;
